import { render } from "./TopKeyword.vue?vue&type=template&id=ed49b130"
import script from "./TopKeyword.vue?vue&type=script&lang=js"
export * from "./TopKeyword.vue?vue&type=script&lang=js"

import "./TopKeyword.vue?vue&type=style&index=0&id=ed49b130&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__